import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/statements';

export default {
  getAll: () => getApiUrl(`${BASE}`),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  getImports: (id) => getApiUrl(`${BASE}/${id}/imports`),
  getReservations: (id) => getApiUrl(`${BASE}/${id}/reservations`),
  getTransfers: (id) => getApiUrl(`${BASE}/${id}/transfers`),
  getFiles: (id) => getApiUrl(`${BASE}/${id}/files`),
  requestFile: (id, featureCategory) => getApiUrl(`${BASE}/${id}/files/${featureCategory}`),
  create: () => getApiUrl(`${BASE}`),
  delete: (id) => getApiUrl(`${BASE}/${id}`),
  updateStatus: () => getApiUrl('/api/statement_transitions'),
};
